<template>
  <section class="footer">
    <div class="wrap">
      <ul class="menu">
        <li>
          <router-link
            class="footer-menu-item"
            :to="`/about/${$t('about.关于MANA')}`"
          >{{$t('global.关于我们')}}</router-link>
        </li>
        <li>
          <router-link
            class="footer-menu-item"
            :to="`/about/${$t('about.用户协议')}`"
          >{{$t('global.用户协议')}}</router-link>
        </li>
        <li>
          <router-link
            :to="`/about/${$t('about.免责声明')}`"
            class="footer-menu-item"
          >{{$t('global.免责声明')}}</router-link>
        </li>
        <li>
          <router-link
            :to="`/about/${$t('about.版权声明')}`"
            class="footer-menu-item"
          >{{$t('global.版权声明')}}</router-link>
        </li>
        <li>
          <router-link
            :to="`/about/${$t('about.侵权申诉')}`"
            class="footer-menu-item"
          >{{$t('global.侵权申诉')}}</router-link>
        </li>
        <li>
          <router-link
            :to="`/about/${$t('about.帮助中心')}`"
            class="footer-menu-item"
          >{{$t('global.帮助中心')}}</router-link>
        </li>
        <li>
          <router-link
            :to="`/about/${$t('about.联系我们')}`"
            class="footer-menu-item"
          >{{$t('global.联系我们')}}</router-link>
        </li>
      </ul>
      <div class="footer-row">
        <div class="footer-copyright">
          <span>© 2016-{{dataYear}} MANA 吗呐 All Rights Reserved.</span>
          <p>
            <a href="http://beian.miit.gov.cn/" target="_blank">沪ICP备16019863号</a>
            <img src="/static/police.png" />
            <a
              href="https://beian.mps.gov.cn/#/query/webSearch?code=31010402333867" target="_blank" 
            >沪公网安备 31010402333867号</a>
          </p>
        </div>
        <div class="footer-contact">
          <el-popover placement="top" width="180" v-model="visible">
            <div class="bottom_wechat_wrap">
              <p>{{$t('global.艺术/设计/科技 跨界创新')}}</p>
              <span>{{$t('global.MANA公众号')}}：mediaart</span>
              <img class="bottom_wechat_qrcode" src="https://image.manamana.net/1627612356000_AzCGbkWx" />
            </div>
            <span slot="reference" class="icon-wechat"></span>
          </el-popover>
          <a
            class="icon-weibo"
            target="_blank"
            href="http://weibo.com/u/2409948564?topnav=1&wvr=6&topsug=1&is_all=1"
          ></a>
          <a class="icon-fb" target="_blank" href="https://www.facebook.com/manamana.net"></a>
          <a class="icon-twitter" target="_blank" href="https://twitter.com/mediaartnewart"></a>
          <a class="icon-in" target="_blank" href="https://www.instagram.com/manamananet"></a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "FooterDown",
  data() {
    return {
      visible: false,
      dataYear: null
    };
  },
  created() {
    var date = new Date();
    this.dataYear = date.getFullYear();
  },
  methods: {}
};
</script>

<style lang="stylus" scoped>
.footer {
  height: 100px;
  background-color: #F5F5F5;
  position: relative;
  z-index: 10;
  padding: 30px 0;
  min-width:1280px;

  .wrap {
    width: 1110px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;

    .menu {
      display: flex;
      flex-direction: row;

      li {
        margin-right: 40px;

        a {
          color: #999;
          font-size: 14px;

          &:hover {
            color: #0A0A0A;
          }
        }
      }
    }

    .footer-row {
      display: flex;
      flex-direction: row;
      padding-top: 30px;
      justify-content: space-between;
      align-items: center;
      position: relative;
      .footer-copyright {
        span {
          color: #999999;
        }

        p {
          padding-top: 10px;

          a {
            color: #B8B8B8;

            img {
              display: inline-block;
              margin: -0.04rem 0.1rem 0;
            }
          }
        }
      }

      .footer-contact {
        position: absolute;
        bottom: 40px;
        right: 0;
        .icon-wechat {
          display: inline-block;
          position: relative;
          width: 26px;
          height: 26px;
          background: url('/static/v2/match/share_wechat.png') no-repeat center center;
          background-size: contain;
          vertical-align: middle;

          img {
            position: absolute;
            max-width: inherit;
            z-index: 99;
            left: -80px;
            bottom: 21px;
          }
        }

        .icon-weibo {
          display: inline-block;
          width: 26px;
          height: 26px;
          background: url('/static/v2/match/share_weibo.png') no-repeat center center;
          background-size: contain;
          margin-left: 26px;
          vertical-align: middle;
        }

        .icon-twitter {
          display: inline-block;
          width: 26px;
          height: 26px;
          background: url('/static/v2/match/share_twitter.png') no-repeat center center;
          background-size: 26px;
          margin-left: 25px;
          vertical-align: middle;
        }

        .icon-fb {
          display: inline-block;
          width: 26px;
          height: 26px;
          background: url('/static/v2/match/share_fb.png') no-repeat center center;
          background-size: 26px;
          margin-left: 25px;
          vertical-align: middle;
        }

        .icon-in {
          display: inline-block;
          width: 26px;
          height: 26px;
          background: url('/static/v2/match/bottom_social_instagram@2x.png') no-repeat center center;
          background-size: 26px;
          margin-left: 25px;
          vertical-align: middle;
        }
      }
    }
  }
}
</style>

<style lang="stylus">
.bottom_wechat_wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 0 5px;

  p {
    font-size: 12px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #0A0A0A;
  }

  span {
    font-size: 12px;
    font-family: NunitoSans-SemiBold, NunitoSans;
    font-weight: 600;
    color: #999;
  }

  .bottom_wechat_qrcode {
    width: 105px;
    height: 105px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/v2/Footer.vue